import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const FloatCoupon = style({
    height: 40,
    paddingLeft: 15,
    paddingRight: 15,
    maxWidth: 480,
    width: '100%',
    cursor: 'pointer',
    backgroundImage: 'linear-gradient(270deg, #DAC888 1%, #EFDCA4 100%)'
})

export const FloatCouponAreaLeftArea = style({
    ...csstips.flexRoot,
    ...csstips.center
})

const animationToLeft = keyframes({
    from : {transform: 'translateX(5px)'},
    to : {transform: 'translateX(0px)'}
})

const animationWaggle = keyframes({
    from : {transform: 'rotate(-30deg)'},
    to : {transform: 'rotate(30deg)'}
})

export const FloatCouponAreaRightArea = style({
    ...csstips.flexRoot,
    ...csstips.center,
    animationName: animationToLeft,
    animationDuration: '500ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-out',
    animationDirection: 'alternate',
    $nest: {
        img: {
            width: 11,
            marginLeft: 6
        },
        p: {
            fontSize: 14,
            color: '#685417',
            letterSpacing: 0,
            fontWeight: 500,
            lineHeight: '14px'
        }
    }
})

export const FloatCouponArea = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.betweenJustified,
    height: '100%'
})

export const FloatCouponAreaImg = style({
    position: 'relative',
    width: 16,
    height: 20,
    animationName: animationWaggle,
    transform: 'rotate(-30deg)',
    animationDuration: '300ms',
    animationIterationCount: 'infinite',
    animationDirection: 'alternate',
    animationTimingFunction: 'linear'
    // ...csstips.flexRoot,
    // ...csstips.center,
})

export const NewYearIcon = style({
    position: 'relative',
    width: 66
})

export const sampleText = style({
    fontSize: 14,
    color: '#685417',
    letterSpacing: 0,
    lineHeight: '14px',
    whiteSpace: 'nowrap',
    marginLeft: 8
})

export const redText = style({
    fontSize: 14,
    color: '#EE6723',
    letterSpacing: 0,
    lineHeight: '14px',
    fontWeight: 500
})

export const CountDownWrap = style({
    position: 'relative',
    marginLeft: 5,
    marginRight: 5
})



// WEBPACK FOOTER //
// ./src/plugins/coupon/floatCoupon.style.ts